import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Box,
  CircularProgress,
  Typography,
  Link as MuiLink,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { STATUS_KEYS } from '../../helpers/options';

const FileProcessingCard = props => {
  const {
    status,
    pendingText,
    resolvedText,
    errorText,
    fileResultUrl,
    goBackText,
    goBackUrl,
  } = props;

  const { t } = useTranslation(['common', 'promptbar']);

  return (
    <Box sx={{ textAlign: 'center' }} mt={7}>
      {status === STATUS_KEYS.PENDING && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              mb: 3,
            }}
          >
            <Typography variant="h1" component="h1" sx={{ fontWeight: 'bold' }}>
              <CircularProgress
                size={20}
                thickness={3}
                color="secondary"
                sx={{
                  mr: 1,
                }}
              />
              {pendingText}
            </Typography>
          </Box>
          <Box>
            <Typography variant="h2" component="h2" mb={2}>
              {t(
                'You can close this page and download the result later using the link',
              ) + ':'}{' '}
              <strong>
                <Link
                  to={window.location.href}
                  className="MuiLink"
                  reloadDocument
                >
                  {window.location.href}
                </Link>
              </strong>
            </Typography>
          </Box>
        </>
      )}

      {status === STATUS_KEYS.RESOLVED && (
        <>
          <Typography variant="h1" component="h1" sx={{ fontWeight: 'bold' }}>
            {resolvedText}
          </Typography>
          {fileResultUrl && (
            <Typography variant="h2" component="p">
              <strong>
                <MuiLink
                  href={process.env.REACT_APP_MEMAS_CORE + '/' + fileResultUrl}
                  underline="always"
                  download
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: '15px auto 0',
                    gap: '8px',
                    padding: '10px 15px',
                    font: 'inherit',
                    backgroundColor: 'var(--color-green-80)',
                    borderRadius: '8px',
                  }}
                  color="textPrimary"
                >
                  <CheckCircleIcon color="success" />
                  {t('Download the result file')}
                </MuiLink>
              </strong>
            </Typography>
          )}
        </>
      )}

      {status === STATUS_KEYS.REJECTED && (
        <Box>
          <Typography
            variant="h1"
            component="h1"
            sx={{ fontWeight: 'bold' }}
            mb={3}
          >
            {errorText}
          </Typography>
          <Typography variant="h2" component="p">
            <strong>
              <Link to={goBackUrl}>{goBackText}</Link>
            </strong>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

FileProcessingCard.propTypes = {
  pendingText: PropTypes.string.isRequired,
  resolvedText: PropTypes.string.isRequired,
  errorText: PropTypes.string.isRequired,
  goBackUrl: PropTypes.string.isRequired,
  goBackText: PropTypes.string.isRequired,
};

export default FileProcessingCard;
